import { QueryFunction,QueryKey,useQuery, UseQueryOptions } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { UserApiService} from 'features/users/api/user-api.service';
import { roleTypeLists } from 'features/users/types';
import {useMemo} from 'react' ;
const {  getRoleTypeList   } = UserApiService();


const getRoleListQuery = (
  options?: UseQueryOptions<roleTypeLists>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<roleTypeLists>;
} => ({
  queryKey: ['roleTypeLists'],
  queryFn: async () => {
    const response = await getRoleTypeList();
    
return response ?? []; // ✅ guarantee return type
  },
  ...options,
});
export const useGetRoleTypes = (
  options?: UseQueryOptions<roleTypeLists>,
) => {
  const { message } = App.useApp();

  const queryConfig = useMemo(() => getRoleListQuery({
    onError: (error: unknown) => {
      const uiMessage = handleError(error);
      message.error(uiMessage);
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry:false,
    ...options,

  }), [options, message]);

  return useQuery<roleTypeLists, Error>({...queryConfig,staleTime: 1000 * 60 * 5,});
};
